module.exports = __webpack_public_path__ + "img/pawelk.6cb2bad3.jpg";